export default "__VITE_ASSET__Bfih_TgC__"